"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.xhrUploadPublisher = void 0;
var NQError_1 = require("./../../NQError");
var R = __importStar(require("ramda"));
var rxjs_1 = require("rxjs");
var utils_1 = require("../../util/utils");
var xhrUploadPublisher = function (byteCount, url, logger) {
    var buffer = new Uint8Array(R.repeat(48, byteCount));
    return new rxjs_1.Observable(function (subscriber) {
        var xhr = new XMLHttpRequest();
        xhr.open("POST", url, true);
        var transferredBytes = 0;
        var reportProgress = function (ev) {
            if (ev.lengthComputable) {
                var nextBytes = ev.loaded > transferredBytes ? ev.loaded - transferredBytes : 0;
                transferredBytes = ev.loaded;
                subscriber.next(nextBytes);
            }
            else {
                //invoked only once (if progress isn't supported) at the end of the request
                subscriber.next(buffer.length);
            }
        };
        xhr.upload.onprogress = function (ev) {
            logger.info({ lengthComputable: ev.lengthComputable, loaded: ev.loaded, total: ev.total }, "uploadPublisher - onprogress, closed = ".concat(subscriber.closed));
            if (subscriber.closed) {
                return;
            }
            reportProgress(ev);
        };
        xhr.upload.onerror = function (ev) {
            logger.error(ev, "uploadPublisher - onerror, closed = ".concat(subscriber.closed));
            var nqInternalError = new NQError_1.NQInternalError(NQError_1.NQInternalErrorCode.UploadError, "Upload Error", (0, utils_1.safeStringify)(ev));
            subscriber.error(new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity, "Upload error", nqInternalError));
        };
        xhr.upload.ontimeout = function (ev) {
            logger.error(ev, "uploadPublisher - ontimeout, closed = ".concat(subscriber.closed));
            var nqInternalError = new NQError_1.NQInternalError(NQError_1.NQInternalErrorCode.UploadTimeout, "Upload Timeout", (0, utils_1.safeStringify)(ev));
            subscriber.error(new NQError_1.NQError(NQError_1.NQErrorCode.Connectivity, "Upload timeout", nqInternalError));
        };
        xhr.upload.onabort = function (ev) {
            logger.info(ev, "uploadPublisher - onabort, closed = ".concat(subscriber.closed));
        };
        /**
         * Here onload is used, and not upload.onloadend. This is because in some circumstances
         * (see ticket https://gitlab.com/anw.net/vodafone/html-speedtest/-/issues/272) the
         * upload.onloadend event is called way too early, and causes unreasonably high speeds.
         */
        xhr.onload = function (ev) {
            logger.info(ev, "uploadPublisher - onload, closed = ".concat(subscriber.closed));
            if (!subscriber.closed) {
                subscriber.complete();
            }
        };
        logger.info("uploadPublisher - sending ".concat(buffer.length, " bytes to ").concat(url));
        xhr.send(buffer);
        var tearDown = function () {
            logger.info("uploadPublisher - tearDown");
            xhr.abort();
        };
        return tearDown;
    });
};
exports.xhrUploadPublisher = xhrUploadPublisher;
//# sourceMappingURL=xhrUploadPublisher.js.map